import { Notice } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import {
  masterStateSelectedAdvisorSelector,
  masterStateSelectedPartnerSelector,
} from '../../../../store/master/selector';

export const PartnerAdvisorsWarning: React.FC = () => {
  const selectedPartner = useRecoilValue(masterStateSelectedPartnerSelector);
  const selectedAdvisor = useRecoilValue(masterStateSelectedAdvisorSelector);

  const isAllAdvisorOrPartnerSelected =
    (selectedPartner !== undefined && selectedPartner === 0) ||
    (selectedAdvisor !== undefined && selectedAdvisor === 0);

  if (isAllAdvisorOrPartnerSelected) {
    return (
      <Notice
        testID="all-advisors-warning-notice"
        backgroundColor={Utils.ColorToken.WithOpacity(
          'feedback.attention.lightest',
          'opacity.medium'
        )}
        textObjects={[
          { text: 'Atenção: ', variant: 'bold' },
          {
            text: ' As visualizações ‘Todas as filiais’ ou ‘Todos os assessores’ não estão disponíveis. Para continuar, selecione o assessor ao qual o cliente está alocado ou utilize o campo de busca no canto superior esquerdo.',
            variant: 'regular',
          },
        ]}
      />
    );
  }

  return null;
};
